import * as React from 'react'

import {cn} from '@/lib/utils'

const Textarea = React.forwardRef<
  HTMLTextAreaElement,
  React.TextareaHTMLAttributes<HTMLTextAreaElement>
>(({className, ...props}, ref) => {
  return (
    <textarea
      className={cn(
        'flex w-full border-b border-gray-subtle bg-gray-10 text-gray-lead p-2 text-sm font-normal placeholder:text-gray-subtle placeholder:font-light focus-visible:outline-none disabled:cursor-not-allowed disabled:bg-gray-20 disabled:border-gray-40 disabled:text-gray-subtle read-only:cursor-not-allowed read-only:bg-gray-20 read-only:border-gray-40 read-only:text-gray-subtle focus:border-blue-p transition-colors hover:border-gray-40 ',
        className,
      )}
      ref={ref}
      {...props}
    />
  )
})
Textarea.displayName = 'Textarea'

export {Textarea}
